import React from 'react';
import { Text, Card } from '@smarterservices/smarter-ui';
import { Responsive, Table } from '@instructure/ui';
import { randomId } from '../../../helpers/utilities';
import DisplayTime from '../../Common/DisplayTime';
import { getStore } from '../../../stores/StoreContext';
const routingData = [
  {
    id: 1,
    detail: 'Begin routing to the proctor location that was scheduled',
    time: '2025-04-22T14:38:00Z',
    proctorAccount: 'SmarterServices Live Proctoring',
  },
  {
    id: 2,
    detail: 'Routed to Greeter Flow RM A',
    time: '2025-04-22T14:39:00Z',
    proctorAccount: 'SmarterServices Live Proctoring',
  },
];

const Routing = (props) => {
  const ExamSession = getStore('examSessionStore');
  return (
    <Responsive
      query={{
        small: { maxWidth: '100px' },
        large: { minWidth: '300px', maxWidth: '100px' },
      }}
      props={{
        small: { layout: 'stacked' },
        large: { layout: 'fixed' },
      }}
    >
      {({ layout }) => (
        <div>
          <Table caption="Routing History" layout="auto">
            <Table.Head>
              <Table.Row>
                <Table.ColHeader id="detail-header">Detail</Table.ColHeader>
                <Table.ColHeader id="time-header">Time</Table.ColHeader>
              </Table.Row>
            </Table.Head>
            <Table.Body>
              {routingData.map((row) => (
                <Table.Row key={row.id}>
                  <Table.Cell
                    key={randomId()}
                    textAlign={layout === 'stacked' ? 'start' : 'start'}
                  >
                    <Text as="div">{row.detail}</Text>
                    <Text as="div">{row.proctorAccount}</Text>
                  </Table.Cell>
                  <Table.Cell
                    key={randomId()}
                    textAlign={layout === 'stacked' ? 'start' : 'start'}
                  >
                    <DisplayTime
                      date={row.time}
                      tz={ExamSession?.userData?.timezone?.name}
                    />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      )}
    </Responsive>
  );
};

export default Routing;
